export default __webpack_public_path__ + "components/weather-icon/static/nightheavyrain@3-35a45582a036b8a814fb1c8518bc838b.png";